"use client"

import React from 'react'
import { Button } from '../../../../shared/components/ui/button'
import FormTextInput from '@/shared/components/form-inputs/form-text-input'
import { useFormContext } from 'react-hook-form'
import { ResetPasswordFormType } from '../../schemas/reset-password.schema'


function ResetPasswordForm() {
    const { control, formState: { isSubmitting } } = useFormContext<ResetPasswordFormType>()

    return (
        <div className="flex flex-col gap-5 w-full">
            <FormTextInput
                type='password'
                placeholder='Password*'
                inputGroupProps={{
                    label: 'Password',
                }}
                name='password'
                control={control}
            />
            <FormTextInput
                type='password'
                placeholder='confirm Password*'
                inputGroupProps={{
                    label: 'Confirm Password',
                }}
                name='confirmPassword'
                control={control}
            />
            <Button className='w-full md:mt-2' showLoader disabled={isSubmitting}>
                Create New Password
            </Button>
        </div>
    )
}

export default ResetPasswordForm